import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1848.71529,357.684706 C1834.82353,342.098824 1813.36471,335.548235 1792.92235,340.517647 C1373.12,445.552941 1162.59765,321.430588 959.077647,201.487059 C756.461176,82.3341176 547.52,-40.6588235 168.941176,103.905882 L168.941176,0 L56,0 L56,1920 L168.941176,1920 L168.941176,227.011765 C521.882353,78.0423529 691.068235,174.72 901.703529,298.842353 C1097.54353,414.155294 1317.55294,543.924706 1713.52471,472.997647 C1542.64471,848.527059 1327.60471,855.868235 1060.61176,865.129412 C826.823529,873.148235 561.863529,882.409412 298.371765,1145.90118 L378.221176,1225.86353 C610.315294,993.769412 841.28,985.863529 1064.56471,977.957647 C1355.38824,967.905882 1656.03765,957.515294 1859.44471,415.171765 C1866.78588,395.52 1862.72,373.383529 1848.71529,357.684706",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFlagLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFlagLine, _Component);

  var _super = _createSuper(IconFlagLine);

  function IconFlagLine() {
    _classCallCheck(this, IconFlagLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFlagLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFlag",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFlagLine.displayName = "IconFlagLine";
  return IconFlagLine;
}(Component);

IconFlagLine.glyphName = 'flag';
IconFlagLine.variant = 'Line';
IconFlagLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFlagLine;
export { IconFlagLine };